import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TransactionFacade } from './+state';
import { TransactionStateModule } from './+state/transaction.state.module';
import { TaxCalculatorService } from './services';
import { TransactionGeneratorService } from './services/transaction-generator.service';
import { TransactionLineProductGeneratorService } from './services/transaction-line-product-generator.service';
import { TransactionTaxRateGeneratorService } from './services/transaction-tax-rate-generator.service';
import { TransactionService } from './services/transaction.service';

@NgModule({
  imports: [CommonModule, TransactionStateModule],
})
export class DomainTransactionModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainTransactionModule,
      providers: [
        TransactionFacade,
        TaxCalculatorService,
        TransactionGeneratorService,
        TransactionLineProductGeneratorService,
        TransactionTaxRateGeneratorService,
        TransactionService,
      ],
    };
  }
}
